import { useDispatch, useSelector } from 'react-redux';
import EditorApprovalProvider from 'ContentEditorUI/components/approvals/EditorApprovalProvider';
import { SuspensionBannersContextProvider
// @ts-ignore not yet migrated
} from 'ui-suspension-banners-lib';
// @ts-ignore not yet migrated
import DetailsContentModBanner from 'content-label-lib/components/DetailsContentModBanner';
import { View } from 'foundations-components/components/View';
import { getIsLandingPage, getIsSitePage } from 'ContentEditorUI/redux/selectors/contentReadOnlyDataSelectors';
import { getContentModelId, getContentModelName } from 'ContentEditorUI/redux/selectors/baseContentModelSelectors';
import { getApprovalContentId } from 'page-editor-ui/redux/selectors/pageContentModelSelectors';
import { getHasApprovalsReadAccess, getHasApprovalsWriteAccess } from 'page-editor-ui/redux/selectors/authSelectors';
import FixInvalidPageExpiryDateController from './FixInvalidPageExpiryDateController';
import { getIsSuggested } from 'ContentEditorUI/redux/selectors/publishSelectors';
import { useEffect, useState } from 'react';
import { useAiEditsPolling } from '../hooks/useAiEditsPolling';
import { useBreezeInteractiveMode } from '../hooks/useBreezeInteractiveMode';
import AiEditsConfirmModal from './AiEditsConfirmModal';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import { useSaveLazyQuery } from '../../__generated__/chirp/com/hubspot/page/content/generator/rpc/AgentGeneratedLandingPagesRpc.hooks';
import { useLocalStorage } from '../hooks/useLocalStorage';
import FormattedMessage from 'I18n/components/FormattedMessage';
// @ts-ignore not yet migrated
import { updateOptimisticLockingForRequest } from 'ContentEditorUI/redux/actions/appActions';
import PageEditorSurfaceMemory from 'page-editor-ui/copilot/surfaceMemory/PageEditorSurfaceMemory';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ExtraApplicationContainerWrapper = ({
  children
}) => {
  const isLandingPage = useSelector(getIsLandingPage);
  const isSitePage = useSelector(getIsSitePage);
  const approvalContentId = useSelector(getApprovalContentId);
  const contentId = useSelector(getContentModelId);
  const approvalAssetName = useSelector(getContentModelName);
  const hasReadAccessToProductApprovals = useSelector(getHasApprovalsReadAccess);
  const hasWriteAccessToProductApprovals = useSelector(getHasApprovalsWriteAccess);
  const dispatch = useDispatch();
  const {
    showConfirmModal,
    onConfirm,
    onDismiss
  } = useAiEditsPolling();
  useBreezeInteractiveMode();
  const isSuggestion = useSelector(getIsSuggested);
  const [hasSeenSuggestedPageAlert, setHasSeenSuggestedPageAlert] = useLocalStorage('hasSeenSuggestedPageAlert', false);
  const [hasSavedSuggestedPage, setHasSavedSuggestedPage] = useState(false);
  const [saveSuggestedPage] = useSaveLazyQuery({
    onCompleted: () => {
      dispatch(updateOptimisticLockingForRequest({
        hasSaved: true,
        // Note, in Chrome I'm now seeing `Refused to get unsafe header "x-last-modified-timestamp"`,
        // even though `Access-Control-Expose-Headers:x-last-modified-timestamp` is set. I think this
        // is a browser bug though (https://stackoverflow.com/questions/5822985/cross-domain-resource-sharing-get-refused-to-get-unsafe-header-etag-from-re#comment6753514_5837798
        // and https://github.com/MiniProfiler/rack-mini-profiler/issues/95)
        xLastModifiedTimestampHeader: Date.now()
      }));
    }
  });
  useEffect(() => {
    if (isSuggestion && isLandingPage && !hasSavedSuggestedPage) {
      saveSuggestedPage({
        variables: {
          contentId
        }
      });
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setHasSavedSuggestedPage(true);
      if (!hasSeenSuggestedPageAlert) {
        FloatingAlertStore.addAlert({
          message: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "suggestedPages.alerts.automaticallySaveToDraft"
          }),
          type: 'info',
          sticky: true
        });
        setHasSeenSuggestedPageAlert(true);
      }
    }
  }, [contentId, isSuggestion, saveSuggestedPage, hasSeenSuggestedPageAlert, setHasSeenSuggestedPageAlert, isLandingPage, hasSavedSuggestedPage]);
  return /*#__PURE__*/_jsx(EditorApprovalProvider, {
    approvalType: isLandingPage ? 'LANDING_PAGE' : isSitePage ? 'SITE_PAGE' : undefined,
    restartOnConclude: isSitePage || isLandingPage,
    hasReadAccessToProductApprovals: hasReadAccessToProductApprovals,
    hasWriteAccessToProductApprovals: hasWriteAccessToProductApprovals,
    contentId: approvalContentId,
    assetName: approvalAssetName,
    children: /*#__PURE__*/_jsxs(View, {
      flexGrow: 1,
      children: [/*#__PURE__*/_jsx(DetailsContentModBanner, {
        contentId: contentId,
        keyWord: "webpage",
        flush: true
      }), /*#__PURE__*/_jsx(FixInvalidPageExpiryDateController, {}), showConfirmModal && /*#__PURE__*/_jsx(AiEditsConfirmModal, {
        onConfirm: onConfirm,
        onDismiss: onDismiss
      }), /*#__PURE__*/_jsxs(SuspensionBannersContextProvider, {
        children: [/*#__PURE__*/_jsx(PageEditorSurfaceMemory, {}), children]
      })]
    })
  });
};
export default ExtraApplicationContainerWrapper;